module.exports = __webpack_public_path__ + "static/kylie-1ff64212a0fcea83285b7f155b019146.jpg";